export default {
  applyTrial: {
    freeTrial: 'Start Free Trial',
    dialog: {
      title: 'Apply for a Trial',
      forbiden: 'No Permission',
      desc: 'To better serve you, please tell us the following before starting the trial service:',
      cancel: 'Cancel',
      applyApproved: 'Application Approved',
      form: {
        pleaseInput: 'Please Enter',
        empty: 'Required',
        atleast: 'At least select one option',
        urlValidator: {
          errorInfo: 'Please input a VALID url',
        },
        full_name: {
          label: 'Contact Name',
        },
        phone: {
          label: 'Phone Number',
        },
        region: {
          label: 'Country or Region',
        },
        company: {
          label: 'Company',
        },
        company_type: {
          label: 'Company Type',
        },
        job_title: {
          label: 'Job title',
        },
        product_type: {
          label: 'Promoted Product Type',
        },
        app_url: {
          label: 'Main Product Store Link',
          placeholder: 'Product Link',
        },
        contact_account: {
          label: 'SMS/Contact Number',
        },
        team_size: {
          label: 'Creative Team Size',
        },
        isMtg: {
          label: 'Previously worked with Mintegral？',
        },
        interested_in: {
          label: 'Interested Features',
        },
        mtg_name: 'Mintegral UserName',
        interesting_gameplay: {
          label: 'Interested Creative Types',
        },
        interesting_videos: {
          label: 'Interested Video Features',
        },
        message: {
          label:
            'Please describe the desired effect of the material production?',
        },
      },
    },
    trialSuccess: {
      tips: 'The Playturbo trial service has been activated for you, valid for {days} days (Expiration date: {expired_date}). Start your creative production journey now!',
      message: 'Trial Activated Successfully',
      ok: 'Got It',
    },
    form: {
      companyType: {
        band: 'Brand Owner',
        agent: 'Agency',
        media: 'Publisher',
        game: 'Game',
        app: 'APP',
        adv: 'Advertiser',
        dev: 'Developer',
        other: 'Other',
      },
      connectType: {
        wechat: 'WeChat',
        skype: 'Skype',
        slack: 'Slack',
        telegram: 'Telegram',
      },
      willFeature: {
        pl: 'Playable Only',
        video: 'Video Only',
        plvideo: 'Playable & Video',
      },
      willVideo: {
        crossover: 'Video Clip Batch Edit',
        mlang: 'Video Multi-language Adaptation',
        mtsize: 'Video Multi-Size Adaptation',
        ai: 'Video AI Removal',
      },
      ismtg: {
        yes: 'Yes',
        no: 'No',
      },
      productType: {
        casual: 'Casual',
        hypercasual: 'Hyper-Casual',
        mid: 'Midcore-Hardcore',
        casino: 'Casino',
        playtoearn: 'Play to Earn',
        entertainment: 'Entertainment',
        social: 'Social App',
        utility: 'Utility',
        education: 'Education',
        finance: 'Finance',
        travel: 'Travel',
        ecommerce: 'Ecommerce',
        other: 'Others',
      },
    },
  },
  totop: {
    contact: {
      title: 'Contact Us',
      desc: 'If you have any questions, please leave a message here with your contact information and account.<br/>Or email us directly at <a href="mailto:playturbo@mindworks-creative.com">playturbo@mindworks-creative.com</a> <br/>We’ll get back to you as soon as we receive your message!',
      dialog: {
        input: {
          placeholder: 'Please describe your issue',
        },
        cancel: 'Cancel',
        submit: 'Submit',
        success: 'Message Sent',
      },
    },
    QRCode: {
      title: 'Scan with WeChat to consult customer support',
    },
  },
}
